import { useLocation, useParams } from "react-router-dom";
import SolicitOption from "../components/SolicitOption";
import Fade from "../components/Fade";
import VoltarBtn from "../components/VoltarBtn";
import HomeBtn from "../components/HomeBtn";
import OutlinedTitle from "../components/OutlinedTitle";
import LogoFooter from "../components/LogoFooter";
// import { atendimentos } from "../store";
import { useEffect, useState } from "react";

export default function Atendimento () {
    const { id: atendimentoId} = useParams();
    // const atendimento = atendimentos.find( atendimento => atendimento.rota === atendimentoId)

    const [atendimento, setAtedimento] = useState()
    const location = useLocation();

    useEffect(() => {
        fetch(`${process.env.REACT_APP_API_URL}/api/tema/${atendimentoId}`, {
            method: "GET"
        }).then((response) => response.json())
        .then((data) => {
            setAtedimento(data)
            // console.log(data)
        })
        .catch((error) => console.log(error))
    }, [location.key])

    return (
        <>
        <Fade>
            <LogoFooter />
            <div className="grid content-center flex-1 grid-rows-[max-content_max-content_max-content] py-8">
                <OutlinedTitle className="">
                    <div className="pl-16 font-tommy text-7xl"><strong>{atendimento?.nome}</strong></div>
                </OutlinedTitle>

                <div className="pl-20 pr-8">
                    <div className="flex flex-col gap-10 justify-between mt-16">
                        {atendimento?.temas.map((servico, i) => 
                            <SolicitOption nome={servico.nome} rota={servico.id} key={servico.id}
                            infos={servico.servicos.length > 0 || servico.sistemas.length > 0}/>
                        )}
                    </div>
                </div>
            </div>
        </Fade>

        <div className="flex justify-between items-center">
            <div className='flex gap-8 px-4 py-8 text-end'>
                <div className='w-40'> <VoltarBtn rota="/atendimento" /></div>
                <div className='w-40'> <HomeBtn/></div>
            </div>
        </div>
        </>
    )
}